import {ReactElement} from 'react'
import {Trans} from 'react-i18next'
import {Link} from 'react-router-dom'
import {Grid} from '@material-ui/core'
import messages from '../../../../../assets/messages'
import NotificationBar from '../../../../Common/NotificationBar'
import {useStyles} from './styles'

type BrokereeAdvancedSettingsNotificationProps = {
  accountId: number
}

export function BrokereeAdvancedSettingsNotification(props: BrokereeAdvancedSettingsNotificationProps): ReactElement {
  const {accountId} = props

  const classes = useStyles()

  return (
    <Grid item xs={12}>
      <NotificationBar status="success">
        <Trans {...messages.brokereeAdvancedSettingsNotification}
          components={[
            <strong className={classes.emphasize}> </strong>,
            <Link to={`${accountId}/settings`} className={classes.link}> </Link>
          ]}/>
      </NotificationBar>
    </Grid>
  )
}
